<input type="text" id="kryptonite.zip" type="hidden">
<input type="text" id="kriptonite.zip" type="hidden">
<input type="text" id="kryptonite.sign" type="hidden">

<app-topo [dadosCertificado]="dadosCertificado"></app-topo>
<app-nome-sistema></app-nome-sistema>

<div *ngIf="!isPerfilValido">
    <app-acesso-negado-generico></app-acesso-negado-generico>
</div>

<div *ngIf="!situacaoCertificado">
    <app-acesso-negado-generico></app-acesso-negado-generico>
</div>

<div *ngIf="certificadoValido === false">
    <app-acesso-sem-registro></app-acesso-sem-registro>
</div>

<div *ngIf="semServico === false">
    <app-acesso-sem-servico></app-acesso-sem-servico>
</div>

<div *ngIf="semServicoNode === false">
    <app-acesso-sem-servico-node></app-acesso-sem-servico-node>
</div>

<div *ngIf="certificadoBloqueado === false">
    <app-acesso-negado></app-acesso-negado>
</div>

<div *ngIf="isPerfilValido && certificadoValido && situacaoCertificado && certificadoBloqueado">
    <app-menu></app-menu>
    <br />
    <router-outlet></router-outlet>
    <app-sistema-carregando></app-sistema-carregando>
</div>

<app-rodape class="alinhamentoRodape"></app-rodape>